import { render, staticRenderFns } from "./widgetWordCloud.vue?vue&type=template&id=36aed402&scoped=true&"
import script from "./widgetWordCloud.vue?vue&type=script&lang=js&"
export * from "./widgetWordCloud.vue?vue&type=script&lang=js&"
import style0 from "./widgetWordCloud.vue?vue&type=style&index=0&id=36aed402&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aed402",
  null
  
)

export default component.exports